import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
import "./filters/index";
import "./plugins/vue-select";
import "./plugins/vue-gtag";
import "./plugins/vue-cookies";
import "./plugins/swiper";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
